  "use strict";
  window.theme = window.theme || {}
  theme.formConciergerie = function () {
    function formConciergerie() {
      this.btn = {
        open_form: document.querySelectorAll(".js-contact-conciergerie"),
        close: document.querySelectorAll(".form__close"),
        overlay: document.querySelectorAll('.contact-form__overlay')
      }
      this.container = {
        form_popup: document.getElementById("contact-form-conciergerie"),
        form_submit_status: document.querySelector('.form-submit-status'),
        success_panel: document.querySelector('.success-panel'),
        contact_header: document.querySelector('.contact__header'),
        form_content: document.querySelector('.form-content'),
        body: document.querySelector('body')
      }

      this.load();

    }
    formConciergerie.prototype.load = function () {
      var _ = this;
      _.btn.open_form.forEach(element => {
        element.addEventListener('click', () => {
          _.openform();
        })
      })
      _.btn.close.forEach(element => {
        element.addEventListener('click', () => {
          _.closeform();
        })
      })
      _.btn.overlay.forEach(element => {
        element.addEventListener('click', () => {
          _.closeform();
        })
      })
      if (_.container.form_submit_status.value === 'false' && _.getFormSubmitStatus('form-conciergerie') === 'close') {
        _.container.form_popup.classList.remove('success');
        _.closeform();
      }
      if (_.container.form_submit_status.value === 'true' && _.getFormSubmitStatus('form-conciergerie') === 'open') {
        _.container.form_popup.classList.add('success');
        _.openform();
      }
    }
    formConciergerie.prototype.openform = function () {
      var _ = this;
      _.activatePageScrollLock();
      _.container.form_popup.classList.add('active');
      window.setTimeout(function () {
        _.container.form_popup.classList.add('visible');
      }, 300);
      _.container.success_panel.style.display = "none";
      _.container.contact_header.style.display = "block";
      _.container.form_content.style.display = "block";
      _.container.body.classList.add('overflow__hidden');
      _.setFormSubmitStatus('open');
      
    }

    formConciergerie.prototype.closeform = function () {
      var _ = this;
      _.container.form_popup.classList.remove('visible');
      window.setTimeout(function () {
        _.container.form_popup.classList.remove('active');
      }, 300);
      _.setFormSubmitStatus('close');
      _.container.form_popup.classList.remove('success');
      _.container.body.classList.remove('overflow__hidden');
      _.deactivatePageScrollLock();
      if (_.container.form_submit_status.value === 'true') {
        window.location = window.location.pathname; //require refresh the page to remove successfull post param
      }
    }

    formConciergerie.prototype.setFormSubmitStatus = function (cvalue) {
      const d = new Date();
      d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = 'form-conciergerie' + "=" + cvalue + ";" + expires + ";path=/";
    }
    formConciergerie.prototype.getFormSubmitStatus = function (cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "close";
    }
    formConciergerie.prototype.activatePageScrollLock = function () {
      document.body.style.margin = 0;
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
    }
    formConciergerie.prototype.deactivatePageScrollLock = function () {
      document.body.style.margin = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    }
    theme.formConciergerie = new formConciergerie;

  }

  theme.formConciergerie();
